module.exports = __webpack_public_path__ + "img/gzyk.bbbb966c.png";